// Client-side id for a row named before its first save (automation steps and
// edges, form fillings). The backend columns are varchar(24), so ids must
// be <= 24 chars (crypto.randomUUID's 36 chars would overflow). 21 url-safe
// chars mirrors the server's short-uuid length.
const ALPHABET =
  "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";

export function localId(): string {
  const len = 21;
  let out = "";
  const cryptoObj = globalThis.crypto;
  if (cryptoObj?.getRandomValues) {
    const bytes = cryptoObj.getRandomValues(new Uint8Array(len));
    for (const byte of bytes) out += ALPHABET.charAt(byte % ALPHABET.length);
  } else {
    for (let i = 0; i < len; i++) {
      out += ALPHABET.charAt(Math.floor(Math.random() * ALPHABET.length));
    }
  }
  return out;
}
